import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthenticationService} from '../core/services/authentication.service';
import { Constants } from '../shared/constants';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private roles = ['ADMN', 'REVWR', 'OPRTN'];

  constructor(private authenticationService: AuthenticationService, private router: Router) {
  }

  canActivate(): boolean {
    const user = JSON.parse(sessionStorage.getItem(Constants.AUTH_TOKEN));
    if (!user) {
      console.log('AuthGuard - User not authenticated.');
      this.router.navigate(['/login']);
      return false;
    }
    const isAuthenticated = this.roles.indexOf(user.roleTypeCode) !== -1;
    if (!isAuthenticated) {
      console.log('AuthGuard - User lacks permission to requested page.');
      return false;
    }
    return isAuthenticated;
  }
}
